import { Colour } from 'components/variables'
import { SRPRS } from 'Icon/srprs'
import EntryRocketModal from '../../pages/entries/modals/EntryRocketModal'
import OriginalModal from '../../pages/entries/modals/OriginalModal'
import TrainPage from '../../pages/entries/trainPage'
import { getCdnUrl } from '../api/cdn'
import { roomType } from '../models/funnelOrder/roomType'
import { Theme } from '../models/funnelOrder/theme'
import { Entry, EntryCategory, EntryKey, EntryType } from './types'

export const commonEntries: Entry[] = [
  {
    name: 'Train',
    key: EntryKey.train,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 104,
    },
    colour: Colour.shalimar,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'train',
      photoWebp: getCdnUrl('train-entry.webp'),
      photo: getCdnUrl('train-entry.jpg'),
      icon: SRPRS.knobs,
    },
    page: {
      name: 'train',
      url: {
        nl: 'train',
      },
      params: {
        theme: Theme.train,
        days: 2,
        roomType: roomType.basic,
      },
      photos: {
        alt: 'Verrassing treinreis - wachten trein duurzaam',
        src: getCdnUrl('train-header-768.jpg'),
        src1024: getCdnUrl('train-header-1024.jpg'),
        src1280: getCdnUrl('train-header-1280.jpg'),
        src1600: getCdnUrl('train-header-1600.jpg'),
        src1920: getCdnUrl('train-header-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      content: {
        explainLeft: 4,
        explainRight: 4,
      },
      overridePage: TrainPage,
    },
  },
  {
    name: 'Customise',
    key: EntryKey.none,
    type: EntryType.Funnel,
    active: false,
    order: {
      nl: 1,
      be: 1,
      uk: 1,
      ie: 1,
      dk: 1,
    },
    colour: Colour.white,
    card: {
      contentKey: 'funnel',
      photoWebp: getCdnUrl('card-customise.webp'),
      photo: getCdnUrl('card-customise.jpg'),
    },
    category: [],
  },
  {
    name: 'Rocket Trip',
    key: EntryKey.none,
    type: EntryType.Modal,
    active: true,
    order: {
      nl: 998,
      be: 998,
      uk: 998,
      ie: 6,
      dk: 998,
    },
    colour: Colour.glory,
    card: {
      contentKey: 'racketreis',
      photoWebp: getCdnUrl('raketreis-card-graphics.webp'),
      photo: getCdnUrl('raketreis-card-graphics.jpg'),
    },
    category: [EntryCategory.originals],
    modal: EntryRocketModal,
  },
  {
    name: 'Your own original',
    key: EntryKey.none,
    type: EntryType.Modal,
    active: true,
    order: {
      nl: 999,
      be: 999,
      uk: 999,
      ie: 999,
      dk: 999,
    },
    colour: Colour.white,
    card: {
      contentKey: 'je-eigen-original',
      photoWebp: getCdnUrl('card-original.webp'),
      photo: getCdnUrl('card-original.jpg'),
    },
    category: [EntryCategory.originals],
    modal: OriginalModal,
  },
]
